import React from 'react';
import Header from '../components/Header';
import PartnersSection from '../components/PartnersSection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const PartnersPage = () => {
  const seoData = {
    title: 'Programa de Partners',
    description:
      'Sumate al programa de Partners de Runamatic y generá ingresos ofreciendo automatización de ventas con IA en WhatsApp, Instagram y Web. Referral, Implementador, Reseller y Etiqueta Blanca.',
    keywords:
      'partners runamatic, programa de partners, referral partner, reseller whatsapp, etiqueta blanca automatización, agencia whatsapp, comisión automatización ventas',
    canonical: '/partners',
    ogTitle: 'Programa de Partners — Runamatic',
    ogDescription:
      'Creá una nueva línea de negocio con Runamatic. Cuatro modelos de partnership para generar ingresos recurrentes ofreciendo automatización inteligente.',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Programa de Partners Runamatic',
      description:
        'Programa de partners para agencias, freelancers y equipos comerciales que quieran generar ingresos ofreciendo automatización de ventas con IA.',
      provider: {
        '@type': 'Organization',
        name: 'Runamatic',
        url: 'https://runamatic.io'
      },
      offers: {
        '@type': 'Offer',
        description: 'Comisiones del 10% por venta + 100% del fee de implementación',
        priceCurrency: 'USD'
      }
    }
  };

  return (
    <>
      <SEO {...seoData} />
      <Header />
      <main>
        <PartnersSection />
      </main>
      <Footer />
    </>
  );
};

export default PartnersPage;
